import { useScopedTranslate } from '@locale/translate';

import { JourneyAction } from 'api/types';
import { getWaitUntilDescription } from 'ui/authenticated/main/helpers';
import { useFlowNodes } from 'ui/journey-builder/hooks/use-nodes';
import { NodeActions } from 'ui/journey-builder/node-types/common';
import { JourneyNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeContainer } from 'ui/journey-builder/node-types/node-container';
import { JourneyNode } from 'ui/journey-builder/node-types/types';

type ActionType = 'wait_for_time';

export const getDescription = (action: JourneyAction<ActionType>) => {
  return getWaitUntilDescription(action.values ?? {});
};

export const Node = (node: JourneyNode<ActionType>) => {
  const { t } = useScopedTranslate(nodeLocale);
  useFlowNodes();

  return (
    <NodeContainer node={node}>
      <JourneyNodeActionCard node={node} label={t('title')}>
        <NodeActions node={node} />
      </JourneyNodeActionCard>
    </NodeContainer>
  );
};

const nodeLocale = {
  en: {
    title: 'Wait for #',
    description:
      'Trigger next action after {daysCount} days, {hoursCount} hours, {minutesCount} minutes',
  },
};
